import { defaultPulsechainProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/pulsechain/default-constants';

export const PULSEX_V2_CONTRACT_ADDRESS = '0x165C3410fC91EF562C50559f7d2289fEbed552d9';

export const PULSEX_V2_PROVIDER_CONFIGURATION = defaultPulsechainProviderConfiguration;
